// this is an autogenerated file from DesignSystem/DataVaxiomEmployeeProfessionalsRelationshipsItem/Edit/Content/Phone/Phones/Content/Phone/Edit/Content/query.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_DataVaxiomEmployeeProfessionalsRelationshipsItem_Edit_Content_Phone_Phones_Content_Phone_Edit_Content(
  $contact_method_id: numeric!
  $person_id: numeric
) {
  vaxiom_contact_method_associations_aggregate(
    where: {
      contact_method_id: { _eq: $contact_method_id }
      person_id: { _neq: $person_id }
    }
  ) {
    aggregate {
      count
    }
  }
}

`